<template>
  <div class="side-bar-right px-gen py-gen">
    <div class="ui accordion" ref="accordionCodigo">
      <div class="title active">
        <h3 class="ui dividing header fdinpro  request-code-">
          {{ $t("request code") }} <i class="dropdown icon"></i>
        </h3>
      </div>
      <div class="ui content active form" ref="formExcel">
        <div class="field">
          <label class="fdinpro label-form cwhite">{{
            $t("customer name")
          }}</label>
          <input
            type="text"
            name="customer_name"
            placeholder=""
            v-model="d.customer_name"
          />
        </div>
        <div class="field">
          <label class="pt-05 fdinpro label-form cwhite">{{
            $t("customer email")
          }}</label>
          <input
            type="text"
            name="customer_email"
            placeholder=""
            v-model="d.customer_email"
          />
        </div>
        <div class="field">
          <label class="pt-05 fdinpro label-form cwhite">{{
            $t("bill or ticket")
          }}</label>
          <input
            type="text"
            name="bill_or_ticket_number"
            placeholder=""
            v-model="d.bill_or_ticket_number"
          />
        </div>
        <div class="field">
          <label class="pt-05 fdinpro label-form cwhite">{{
            $t("product type")
          }}</label>
          <div class="ui selection dropdown" ref="product_type_dropdown">
            <input type="hidden" name="product_type" />
            <i class="dropdown icon"></i>
            <div class="default text"></div>
            <div class="menu"></div>
          </div>
        </div>
        <div class="field">
          <label class="pt-05 fdinpro label-form cwhite">{{
            $t("gpu type")
          }}</label>
          <div class="ui selection dropdown" ref="gpu_type_dropdown">
            <input type="hidden" name="gpu_type" />
            <i class="dropdown icon"></i>
            <div class="default text"></div>
            <div class="menu"></div>
          </div>
        </div>
        <div class="field">
          <label class="pt-05 fdinpro label-form cwhite">{{
            $t("brand")
          }}</label>
          <div class="ui selection dropdown" ref="brand_dropdown">
            <input type="hidden" name="brand" />
            <i class="dropdown icon"></i>
            <div class="default text"></div>
            <div class="menu"></div>
          </div>
        </div>
        <div class="field">
          <label class="pt-05 fdinpro label-form cwhite">{{
            $t("card or notebook serial")
          }}</label>
          <input
            type="text"
            name="card_or_notebook_serial"
            placeholder=""
            v-model="d.card_or_notebook_serial"
          />
        </div>
        <div class="ui error message" ref="formError"></div>
        <div
          class="ui fluid button modal-button-green"
          tabindex="0"
          @click="send"
        >
          {{ $t("send") }}
        </div>
      </div>
      <excel-upload ref="excel_upload" />
    </div>
  </div>
</template>

<script>
import { local_api, error_toast, success_toast } from "@/utils";
import ExcelUpload from "./ExcelUpload.vue";

export default {
  name: "NworkforceStoreCodeRequest",
  components: {
    ExcelUpload,
  },
  data() {
    return {
      d: {
        customer_name: "",
        customer_email: "",
        bill_or_ticket_number: "",
        product_type: "",
        gpu_type: "",
        brand: "",
        card_or_notebook_serial: "",
      },
      c: {
        product_type_dropdown: undefined,
        gpu_type_dropdown: undefined,
        brand_dropdown: undefined,
      },
      gpus: [],
      brands: [],
      product_types: [],
      all_gpus: [],
      all_brands: [],
      bundles: [],
    };
  },
  computed: {
    form() {
      let vm = this;
      return window.jQuery(vm.$refs.formExcel).form({
        fields: {
          customer_name: ["empty"],
          customer_email: ["empty", "email"],
          bill_or_ticket_number: ["empty"],
          product_type: ["empty"],
          gpu_type: ["empty"],
          brand: ["empty"],
          card_or_notebook_serial: ["empty"],
        },
      });
    },
  },
  mounted() {
    let vm = this;
    local_api(vm, "post", "/nvidia_ticket/store/do-get-code-request-config", {})
      .then(function(r) {
        if (r && r.brands) {
          let brnds = r.brands.map((b) => {
            return { name: b.setup.name, value: b.brand_id, brand: b };
          });
          vm.all_brands = brnds;
          vm.setBrands(brnds);
        }
        if (r && r.cards) {
          let crds = r.cards.map((b) => {
            return { name: b.setup.name, value: b.graphic_card_id, card: b };
          });
          vm.all_gpus = crds;
          vm.setGPUs(crds);
        }
      })
      .catch(function(err) {
        error_toast(err);
      });
    let itms = ["card", "desktop", "laptop"];
    vm.setProductTypes(
      itms.map((i) => {
        return { name: vm.$t(i), value: i };
      }),
    );
    window.jQuery(vm.$refs.accordionCodigo).accordion({
      onOpening() {
        setTimeout(() => {
          window.jQuery(vm.$refs.formError).hide();
        }, 15);
      },
    });

    // vm.setGPUs([{ name: "uno", value: "uno" }]);
    // vm.setBrands([{ name: "dos", value: "dos" }]);
  },
  methods: {
    setGPUs(gpus) {
      this.gpus = gpus;
    },
    setBrands(brands) {
      this.brands = brands;
    },
    setProductTypes(types) {
      this.product_types = types;
    },
    send() {
      let vm = this;
      let isFormValid = true;
      isFormValid = vm.form.form("validate form");
      if (isFormValid) {
        let bdls = vm.bundles.filter((b) => {
          let red = b.setup.cards.reduce((prev, curr) => {
            if (prev == false) {
              let r = String(curr) == String(vm.d.gpu_type);
              return r;
            } else {
              return true;
            }
          }, false);
          return red;
        });
        vm.$emit("bdls", bdls);
        local_api(vm, "post", "/nworkforce/store/do-request-code", {
          d: vm.d,
          b: bdls,
        })
          .then(function() {
            success_toast(vm.$t("codes sent"));
            vm.$emit("code_requested");
          })
          .catch(function(err) {
            error_toast(err);
          });
      }
    },
    setBundles(bundles) {
      this.bundles = bundles;
      this.$refs.excel_upload.setBundles(bundles);
    },
  },
  watch: {
    gpus: function() {
      let vm = this;
      vm.c.gpu_type_dropdown = window
        .jQuery(vm.$refs.gpu_type_dropdown)
        .dropdown("setup menu", { values: vm.gpus })
        .dropdown({
          onChange(value) {
            vm.d.gpu_type = value;
            // vm.brands = vm.all_brands.filter((g) => {
            //   let trgtType = value;
            //   if (trgtType == "card") return g.card.setup.for_discrete;
            //   else if (trgtType == "desktop") return g.card.setup.for_desktop;
            //   else if (trgtType == "laptop") return g.card.setup.for_laptop;
            // });
          },
        });
    },
    brands: function() {
      let vm = this;
      vm.c.brand_dropdown = window
        .jQuery(vm.$refs.brand_dropdown)
        .dropdown("setup menu", { values: vm.brands })
        .dropdown({
          onChange(value) {
            vm.d.brand = value;
          },
        });
    },
    product_types: function() {
      let vm = this;
      vm.c.product_type_dropdown = window
        .jQuery(vm.$refs.product_type_dropdown)
        .dropdown("setup menu", { values: vm.product_types })
        .dropdown({
          onChange(value) {
            vm.d.product_type = value;
            vm.gpus = vm.all_gpus.filter((g) => {
              let trgtType = value;
              if (trgtType == "card") return g.card.setup.for_discrete;
              else if (trgtType == "desktop") return g.card.setup.for_desktop;
              else if (trgtType == "laptop") return g.card.setup.for_laptop;
            });
          },
        });
    },
  },
};
</script>

<style scoped>
/* @import url("https://nworkforce.com/librerias/css/fonts/fonts.css"); */

.side-bar-right {
  flex: 24%;
  z-index: 5;
  background-color: #2e363b;
  display: flex;
  flex-direction: column;
}
.px-gen {
  padding-right: 2rem !important;
  padding-left: 2rem !important;
} /*gen controla padding de los 3 modulos principales*/
.py-gen {
  padding-top: 5.5rem;
  padding-bottom: 0;
}
.fdinpro {
  font-family: "DINPro" !important;
}
.request-code- {
  color: white !important;
  border-bottom: 2pt solid white !important;
  font-weight: 300;
  font-size: 1.5rem !important;
  text-transform: uppercase !important;
}
.label-form {
  font-size: 0.8rem !important;
}
.cwhite {
  color: white !important;
}
.modal-button-green {
  background-color: #365a0c !important;
  color: white !important; /*width: 100%;*/
  font-family: "DINPro" !important;
  font-weight: 500;
}
.modal-button-green:hover {
  background-color: rgb(118, 185, 0) !important;
}
</style>
